import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('benefits_set_external_id',
  '/plan_external_ids',
  'show')
const actions = generator.generate()

export default actions
